import React from 'react';
import PropTypes from 'prop-types';
import AccountCardComponent from './AccountCardComponent';

/**
 * @todo This component is really just a "passthrough", wrapping `AccountCardComponent` in a div with a css class.
 * Consider adding the div where AccountSummary is used in order to reduce the size of the component tree.
 */
export const AccountSummary = ({
  accountId,
  onAccountSelect,
  openMore,
  openCloseMore,
  collapsibleButtonName,
  iconId,
  content = {},
}) => (
  <div className="account-summary--doc">
    <AccountCardComponent
      accountId={accountId}
      onAccountSelect={onAccountSelect}
      openMore={openMore}
      openCloseMore={openCloseMore}
      collapsibleButtonName={collapsibleButtonName}
      iconId={iconId}
      content={content}
    />
  </div>
);

AccountSummary.propTypes = {
  accountId: PropTypes.string.isRequired,
  content: PropTypes.object,
  onAccountSelect: PropTypes.func.isRequired,
  openMore: PropTypes.bool,
  openCloseMore: PropTypes.func.isRequired,
  collapsibleButtonName: PropTypes.string.isRequired,
  iconId: PropTypes.string.isRequired,
};
